<template>
    <div class="box_shadow">
        <div class="post">
            <ul>
                <li>
                    <p>{{postDetail.title}}</p>
                    <!-- <p v-bind:class="{active:item.postType=='置顶'}">{{item.title}}</p> -->
                    <div class="post_content">
                        <div class="left">
                            <!-- <img src="../assets/img/head.png" alt="" width="10%"> -->
                            <img :src="postDetail.avatar || defaultPlayerSrc" alt="" v-if="postDetail.role_name !== '管理员'" width="10%">
                            <img :src="postDetail.avatar || defaultAdminSrc" alt="" v-if="postDetail.role_name == '管理员'" width="10%">
                            <div class="name_txt">
                                <span class="name txt_one">{{postDetail.role_name}}</span>
                                <span class="name txt_one"><span v-if="postDetail.role_name !== '管理员'" class="txt_one">( {{postDetail.sname}} )</span></span>
                            </div>
                            <span class="time">{{postDetail.published_at}}</span>
                        </div>
                        <div class="right em_all_icon">
                            <div class="all_flex"><em class="eye"></em><i>{{postDetail.view_count | numberLimit}}</i></div>
                            <div class="all_flex" @click.prevent="like(postDetail)" :class="{current:postDetail.is_liked==true}">
                                <em class="like"></em><i>{{postDetail.like_count | numberLimit }}</i></div>
                            <div class="all_flex" v-on:click="handleFocus()">
                                <em class="chat"></em><i>{{postDetail.comment_count | numberLimit}}</i>
                            </div>
                            <div class="inform-btn box_shadow" v-on:click="handlePostInform()">
                                <span>舉報</span>
                            </div>
                        </div>
                    </div>
                    <div class="content" v-html="postDetail.content">
                    </div>
                </li>
            </ul>
        </div>
        
    </div>
</template>

<script>
export default {
    name:'DetailTop',
    props:{
        postDetail:Object,
        isMask:Boolean
    },
    data () {
        return {
            defaultPlayerSrc:'../../img/people.png',
            defaultAdminSrc:'../../img/admin.png',
        }
    },
    computed: {
        userInfo () {
            return this.$store.state.userInfo
        }
    },
    filters:{
        numberLimit (value) {
            if(value > 999){
                value = '999+'
            }
            return value
        }
    },
    methods: {
        handlePostInform() {
            this.$emit('handlePostInform');
        },
        handleFocus() {
            // this.refs.postComments.focus();
        },
        like (item) {
            item.is_liked = !item.is_liked;
            if(item.is_liked == true){
                item.like_count++;

            } else {
                item.like_count--;
            }
            let api = '/topic/like';
            let t =this;
            t.$http.post(api,{
                    topic_id: item.id,
                    app_user_id: t.userInfo.app_user_id
                })
                .then((res) => {
                    console.log('dianzan',res.data);
                    if(res.data == true) {
                        // this.$toast("点赞成功！")
                    }
                })
        }
    },
}
</script>

<style lang="stylus" scoped>
@media all and (orientation : landscape)
    .post
        width 100%
        margin: 2vh auto
        .inform-btn
            width .9rem
            height: .4rem;
            color:#fe8124;
            border: 1px solid #fe8124;
            text-align: center;
            font-size: .245rem;
            vertical-align: middle;
            border-radius: 2px;
            margin-left: 11%;
            margin-top: .1rem;
            border-radius 4px
            cursor pointer
            display flex
            align-items center
            justify-content center
        .current
            color: #d2a852 !important
        ul
            width 100%
            height 100%
            li
                line-height .6rem
                font-size 0.275rem
                color #fff
                text-align left
                padding 0 0.2rem
                padding-bottom .08rem
                p
                    word-break break-all
                    color:#333333
                    font-size .3rem
                .active
                    color: #19a15f
                .subAdd
                    margin-left 5%
                .content
                    overflow: hidden
                    word-break: break-word
                    padding 1% 0
                    p
                        color: #4c4c4c !important
                        span
                            color: #4c4c4c !important
                    img
                        max-width 100%
                .post_content
                    display flex
                    border-bottom 1px solid #cccccc
                    padding-bottom: .04rem
                    .post_rw
                        flex .3!important
                    .left
                        flex 1.1
                        .name_txt{
                            display flex
                            width: 33vw
                        }
                        img
                            float: left
                            margin-right: 3%
                            margin-top:4%
                            border-radius: 100%
                            width: .59rem;
                            height: .59rem;
                        .r
                            display flex
                            flex-direction column
                            i
                                color: #fff
                                background: #19a15f
                                padding: .01rem .06rem
                                font-size: .1rem
                                margin-right: 3%
                            p
                                flex 1
                                &.name
                                    color #d2a852
                        span
                            &.name
                                padding-left 0%
                                margin-right 1vw
                                color #333333
                                span
                                    width 100%
                            &.time
                                width 76%
                                color #999999
                                font-size .24rem
                    .right
                        flex 1
                        display flex
                        text-align right
                        .all_flex
                            flex 1
                            cursor pointer
                        div
                            a
                                color #fff
                            .van-icon
                                display inline-block
                                margin-top 0
                                margin-right 6%
                                font-size .24rem
                                color #666666
                            i
                                display inline-block
                                font-style normal
                                vertical-align middle
                                font-size .24rem
                                color #666666
@media all and (orientation : portrait)
    .post
        width 100%
        margin-top 6.9vh
        background #333
        .inform-btn
            height: .3rem;
            line-height: .3rem;
            text-align: center;
            font-size: .245rem;
            vertical-align: middle;
            border-radius: 2px;
            flex: 1;
            margin-top:2%
            span
                display inline-block
                padding 0 .1rem
                border: 1px solid #ccc
        .current
            color: #d2a852 !important
        ul
            width 100%
            height 100%
            li
                line-height .6rem
                font-size 0.275rem
                color #fff
                text-align left
                padding 0 0.1rem
                padding-bottom .08rem
                .active
                    color: #19a15f
                .subAdd
                    margin-left 5%
                .content
                    overflow: hidden
                    word-break:break-word
                    padding 2% 0
                    img
                        max-width 100%
                .post_content
                    display: flex;
                    border-bottom: 1px solid #797979;
                    padding-bottom: 0.04rem;
                    flex-direction: column;
                    justify-content: center;
                    .post_rw
                        flex .3!important
                    .left
                        flex 1.1
                        img
                            float: left
                            margin-right: 3%
                            margin-top 2%
                        .r
                            display flex
                            flex-direction column
                            i
                                color: #fff
                                background: #19a15f
                                padding: .01rem .06rem
                                font-size: .1rem
                                margin-right: 3%
                            p
                                flex 1
                                &.name
                                    color #d2a852
                        span
                            display inline-block
                            &.name
                                width 76%
                                padding-left 0%
                                padding-right 6%
                            &.time
                                width 76%
                                padding-right 6%
                    .right
                        flex 1.1
                        display flex
                        text-align center
                        div
                            display inline-block
                            flex 1
                            a
                                color #fff
                            .van-icon
                                display inline-block
                                margin-top 0
                                margin-right 6%
                                font-size .325rem
                                color #fff
                            i
                                display inline-block
                                font-style normal
                                vertical-align middle

</style>